module.exports = __webpack_public_path__ + "images/store_case_study/wink-pic2_86730a8b3103fea3846ae0152e2fd3ed.png";